import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

const DIRECTORS = [
  { name: "Kevin Jain", initials: "KJ" },
  { name: "Nilesh Koli", initials: "NK" },
];

const Card = ({ d, i }) => (
  <Reveal delay={i * 0.12}>
    <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}
      className="group relative flex items-center gap-6 overflow-hidden rounded-[28px] border border-navy/10 bg-white p-6 sm:gap-8 sm:p-8" data-testid={`director-card-${i}`}>
      <div className="relative grid h-24 w-24 shrink-0 place-items-center rounded-full bg-navy sm:h-28 sm:w-28">
        <span className="absolute inset-1.5 rounded-full border border-gold-light/40 transition-transform duration-700 group-hover:rotate-180" style={{ borderStyle: "dashed" }} />
        <span className="gold-shimmer font-serif text-4xl italic sm:text-5xl">{d.initials}</span>
      </div>
      <div className="min-w-0">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-gold">Director</p>
        <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl" data-testid={`director-name-${i}`}>{d.name}</h3>
        <p className="mt-2 text-sm text-slate-600">Zenura Metals</p>
      </div>
      <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-gradient-to-r from-gold to-gold-light transition-[width] duration-700 group-hover:w-full" />
    </motion.div>
  </Reveal>
);

export const Leadership = () => (
  <section id="leadership" className="bg-white pb-12 pt-24 sm:pb-16 sm:pt-32" data-testid="leadership-section">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Eyebrow>Leadership</Eyebrow>
        <Reveal>
          <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-navy sm:text-5xl">
            The people behind <em className="font-serif font-normal italic text-gold">every</em> trade.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-slate-600">Zenura Metals is led by its directors, who personally stand behind every partnership we build.</p>
        </Reveal>
      </div>
      <div className="grid content-center gap-5 lg:col-span-8 lg:grid-cols-2">
        {DIRECTORS.map((d, i) => <Card key={d.name} d={d} i={i} />)}
      </div>
    </div>
  </section>
);
